import { get } from "lodash-es";

/** Rows of result set `table` from a MESApiService.callV2 response. */
export const getTableRows = <T>(resp: unknown, table: number): T[] =>
	get(resp, `data.tables[${table}].rows`, []) as T[];
